import * as SDPUtils from 'sdp';
export function censor(value) {
    if (value === null || value === undefined) {
        return value;
    }
    if (value instanceof BaseConfidential) {
        return value.censored();
    }
    if (value.constructor === String) {
        return `[String: length=${value.length}]`;
    }
    if (value instanceof Array) {
        return value.map((item) => censor(item));
    }
    if (value instanceof ArrayBuffer) {
        return `[ArrayBuffer: length=${value.byteLength}]`;
    }
    if (value instanceof Uint8Array) {
        return `[Uint8Array: length=${value.byteLength}, offset=${value.byteOffset}]`;
    }
    if (value instanceof Blob) {
        return `[Blob: length=${value.size}, type=${value.type}]`;
    }
    if (value.constructor === Object) {
        const object = {};
        for (const [k, v] of Object.entries(value)) {
            object[k] = censor(v);
        }
        return object;
    }
    return `[${value.constructor.name}]`;
}
export class BaseConfidential {
}
export class ConfidentialArray extends BaseConfidential {
    array;
    constructor(array) {
        super();
        this.array = array;
    }
    get uncensored() {
        return this.array.map((item) => item.uncensored);
    }
    censored() {
        return this.array.map((item) => item.censored());
    }
}
export class ConfidentialObjectValues extends BaseConfidential {
    uncensored;
    constructor(object) {
        super();
        this.uncensored = object;
    }
    censored() {
        return censor(this.uncensored);
    }
}
export class ConfidentialWireMessage extends BaseConfidential {
    uncensored;
    constructor(message) {
        super();
        this.uncensored = message;
    }
    censored() {
        const message = Object.assign({}, this.uncensored);
        if (message.args !== undefined) {
            message.args = censor(message.args);
        }
        if (message.data !== undefined) {
            message.data = censor(message.data);
        }
        return message;
    }
}
export class ConfidentialIceCandidate extends BaseConfidential {
    uncensored;
    constructor(candidateSdp) {
        super();
        this.uncensored = candidateSdp;
    }
    censored() {
        try {
            const candidate = SDPUtils.parseCandidate(this.uncensored);
            if (candidate.type !== 'relay') {
                candidate.address = candidate.ip = ConfidentialIceCandidate.censorIp(candidate.address);
            }
            if (candidate.relatedAddress !== undefined) {
                candidate.relatedAddress = ConfidentialIceCandidate.censorIp(candidate.relatedAddress);
            }
            return SDPUtils.writeCandidate(candidate);
        }
        catch (error) {
            return this.uncensored;
        }
    }
    static censorIp(ip) {
        if (ip.includes('-')) {
            return ip;
        }
        const ipv4 = ip.split('.');
        if (ipv4.length > 1) {
            return `${ipv4.slice(0, 2).join('.')}.*.*`;
        }
        const ipv6 = ip.split(':');
        const head = ipv6.shift();
        return `${head}:${ipv6.map((item) => item.length > 0 ? '*' : item).join(':')}`;
    }
}
